/**
 * Holds the lazily loaded EvaluationsRootMachine logic after dynamic import.
 * RootMachine's /evaluations.ready invoke reads this so the evaluations bundle
 * is not pulled into the main chunk.
 */
export const evaluationsMachineLogicRef = { current: null };
